<template>
  <PlayerPage :loading="loading" :white="false"
    :displayLog="displayLog" @displayLog="displayLog = $event">
    <!-- <title-bar></title-bar> -->
    <!-- <result-nav :eno="$route.params.id"></result-nav> -->
    <div class="log-ctrl">
      <!-- <b-button size="sm" @click="$store.dispatch('skipCode')">ログスキップ</b-button> -->
      <!-- <social-sharing :url="$store.getters.clientURL+'#/result/'+eno"
                        :title="nickname+'が'+location+'で'+action"
                        hashtags="不奇跡世界"
                        inline-template>
        <network network="twitter" class="tweet">
          <font-awesome-icon :icon="['fab', 'twitter']" class="fa-1x" />
          <span>Tweet</span>
        </network>
      </social-sharing> -->
      <!-- <span v-if="month > 0" class="date">更新日：{{month}}/{{day}}</span> -->
      <b-button class="close" style="position:absolute; right:5px" variant="danger" @click="displayLog = false">
        <b-icon icon="x" />
      </b-button>
    </div>
    <battle-note :code="code" :pt1="pt1" :pt2="pt2"></battle-note>
    <pagenate>
      <template v-if="$route.params.id" #previous>
        <b-icon icon="chevron-left" />
        <router-link :to="`/status/${$route.params.id}`">ステータス</router-link>
      </template>
      <template v-else #next>
        <router-link to="/status">ステータス</router-link>
        <b-icon icon="chevron-right" />
      </template>
    </pagenate>
    <a v-if="$store.getters.recorder"
      :href="$store.getters.recorder"
    >Download</a>
  </PlayerPage>
</template>

<script>
import { phina, canvasInit } from '@/canvas'
import store from '@/store'
import PlayerPage from '@/components/PlayerPage'
import CheckLogin from '@/components/mixin-checkLogin'
// import TitleBar from '@/components/TitleBar'
import BattleNote from '@/components/BattleNote'
// import ResultNav from '@/components/ResultNav'
import Pagenate from '@/components/Pagenate'
export default {
  components: {
    PlayerPage,
    // TitleBar,
    BattleNote,
    // ResultNav
    Pagenate
  },
  data () {
    return {
      loading: false,
      displayLog: true,
      pt1: [],
      pt2: [],
      code: []
    }
  },
  mixins: [
    CheckLogin
  ],
  methods: {
    setData (response) {
      this.action = response.action
      this.pt1 = response.pt1
      this.pt2 = response.pt2
      this.$store.dispatch('setCode', response.code)

      phina.global.app.one('started', ()=>{
        // eslint-disable-next-line
        phina.global.app.pushScene(RequestScene({
          assets: response.assets,
          success: (_response, args)=>{
            this.code = response.code
            args.$extend({ 
              player:response.pt1, enemy:response.pt2,
              out:response.code 
            })
            .$extend({ store:this.$store, bg:'img/ui/bg.png' });
            return 'BattleScene'
          }
        }))
      })
    }
  },
  beforeRouteEnter (route, redirect, next) {
    store.dispatch('getBattleLog', route.params)
      .then((response) => {
        next(vm => vm.checkService(response))        
      })
  },
  created () {
    if(!this.$route.params.id){
      this.checkLogin()
    }
    this.$store.dispatch('setCode', [])
  },
  mounted () {
    phina.main(canvasInit);
    this.$store.dispatch('setCode', [])
    this.$store.dispatch('setThreadPosition', 'right')
    // phina.global.app.currentScene.exit('TitleScene')

    //描画コンテキストの取得
    // var canvas = document.getElementById('game');
    // var context = canvas.getContext('2d');
    // context.fillRect(0,0,1000,600);
  },
  destroyed () {
    this.$store.dispatch('setRecorder', null);
    this.$store.dispatch('setThreadPosition', 'center')
  }
}
</script>

<style lang="scss" scoped>
.tweet:hover {
  background-color: #0b85d0;
}
.tweet {
  display: inline-block;
  height: 30px;
  border-radius: 4px;
  padding: 1px 10px;
  background-color: #1b95e0;
  color: #FFF;
  cursor: pointer;
  margin: 2px;
}
.date {
  background-color: #FFF;
}
.log-ctrl {
  position: relative;
  width: 100%;
  pointer-events: visible;
}

</style>
